import * as React from 'react';

export function ForceCrash(): JSX.Element {
  throw new Error('SRE Forced crash');
  return <div />;
}
